export default {
  // Blog article metadata
  date: '23. januar 2025',
  author: 'NicolasKJ.dk',
  
  // Hero section
  heroTitle: 'NicolasKJ.dk rangerede Enkel Energi som billigst i sin test',
  heroSubtitle: 'En uafhængig analyse på NicolasKJ.dk (januar 2025) kårede Enkel Energi som det billigste elselskab i sammenligningen.',
  
  // Intro
  intro: 'NicolasKJ.dk, en uafhængig forbrugerside, har gennemført en analyse af elselskaber i Danmark. I den sammenligning kom Enkel Energi ud som det billigste selskab. Resultatet gælder analysens forudsætninger og tidspunkt.',
  
  // What Nicolas highlights
  whatNicolasHighlights: 'Hvad Nicolas fremhæver',
  whatNicolasIntro: 'NicolasKJ.dk påpeger flere centrale fordele ved Enkel Energi:',
  highlight1: 'Spotpris 1:1 uden tillæg – gennemsigtighed i prisfastsættelsen',
  highlight2: 'Lave abonnementsomkostninger sammenlignet med konkurrenterne',
  highlight3: 'Inkluderet Saving Mode-app til elbil-ejere uden ekstra omkostninger',
  highlight4: 'Ingen binding – fleksibilitet til at skifte når som helst',
  methodNote: 'Analysen baserer sig på en sammenligning af priser, vilkår og serviceydelser uden brug af affiliate-links. Priser og placeringer ændrer sig over tid – tjek de aktuelle priser før du vælger.',
  
  // Independent analysis
  independentTitle: 'En uafhængig analyse uden affiliatelinks',
  independentText1: 'Det særlige ved NicolasKJ.dk\'s analyse er, at den ikke indeholder affiliate-links eller reklamepartnerskaber med elselskaberne. Dette sikrer, at konklusionerne er baseret udelukkende på objektive kriterier som pris, serviceniveau og kundetilfredshed.',
  independentText2: 'For forbrugere betyder det information uden skjulte kommercielle interesser, når de skal vælge elselskab.',
  
  // Thanks section
  thanksTitle: 'Tak til NicolasKJ.dk',
  thanksText: 'Vi er stolte af placeringen i en grundig og uafhængig analyse. Det bekræfter vores mission om at gøre el billigere og mere gennemskueligt for alle danskere.',
  
  // Read full comparison
  readFullComparison: 'Læs hele sammenligningen hos NicolasKJ.dk:',
  
  // Welcome
  welcomeText: 'Velkommen til Enkel Energi – hvor du får billig el uden de skjulte tillæg.',
  
  // CTA section
  ctaTitle: 'Klar til at spare penge på din el?',
  ctaSubtitle: 'Skift til spotpris uden tillæg og få gennemsigtige priser uden binding.',
  seeElPlans: 'Se el-aftaler',
  comparePrices: 'Sammenlign priser',
};